// Add this at the end of cart.mini.js

document.addEventListener('DOMContentLoaded', function() {
    const addToCartButton = document.querySelector('.product-form__cart-submit');
    
    if (addToCartButton) {
        addToCartButton.addEventListener('click', function(event) {
            const loader = addToCartButton.querySelector('[data-loader]');
            loader.classList.remove('hide'); // Show loader when clicked
            
            // Simulate AJAX Add to Cart (you may need to replace this with actual AJAX logic if required)
            setTimeout(() => {
                loader.classList.add('hide'); // Hide loader after adding to cart
                window.location.href = "/cart"; // Redirect to cart page
            }, 2000); // Adjust the time as needed
        });
    }
});
